import {AddItemResponseStatus_Success_Section} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import React from 'react';
import {MultipleItemsPriceDecreased} from './MultipleItemsPriceDecreased';
import {SingleItemPriceDecreased} from './SingleItemPriceDecreased';

export const AddToBasketSuccessSections: React.FC<{
  className?: string;
  statusSuccessSections: AddItemResponseStatus_Success_Section[];
}> = ({className, statusSuccessSections}) => {
  if (!statusSuccessSections.length) {
    return null;
  }

  return (
    <>
      {statusSuccessSections.map(section => {
        switch (section.type?.$case) {
          case 'unlockedTierForSingleItem':
            return (
              <SingleItemPriceDecreased
                className={className}
                unlockedTierForSingleItem={
                  section.type.unlockedTierForSingleItem
                }
              />
            );
          case 'couponBasketItemsPriceDecreased':
            return (
              <MultipleItemsPriceDecreased
                className={className}
                couponBasketItemsPriceDecreased={
                  section.type.couponBasketItemsPriceDecreased
                }
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};
